import { ActionReducer, ActionReducerMap, createFeatureSelector, createReducer, createSelector, MetaReducer, on } from '@ngrx/store';
import { Msg, User, UserToken } from '../../model/user.model';
import { AuthActions } from '../action-types';

const createEmptyUserToken = () => {
    return { token: '', user: {}, msg: {} };
};

export interface AuthState {
    userToken: UserToken;   
    loggedIn: boolean;
    loggedOut: boolean;
    user: any;
    logoutSuccess: boolean; 
    error: any;
}

export const initialAuthState: AuthState = {
    userToken: createEmptyUserToken(),
    loggedIn: true,
    loggedOut: false,
    user: null,
    logoutSuccess: false,
     error: null,
};

export const authReducer = createReducer(
    initialAuthState,

    on(AuthActions.login, (state, action) => {
        return {
            userToken: action.userToken,
            loggedIn: false,
            loggedOut: true,
            user: null,
            logoutSuccess: false,
            error: null,        
        };
    }),
    
    on(AuthActions.tokenLogin, (state, action) => {
        return {
            userToken: action.userToken,
            loggedIn: false,
            loggedOut: true,
            user: null,
            logoutSuccess: false,
            error: null,
        };
    }),

    on(AuthActions.logout, (state, action) => ({
        userToken: createEmptyUserToken(),
        loggedIn: false,
        loggedOut: true,
        user: null,
        logoutSuccess: true,
        error: null,
    })),
    on(AuthActions.logoutFailure, (state) => ({
        ...state,
        loggedOut: false
      }))   
);
